var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisaDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.991699,
    width: 35.004,
    height: 24,
    rx: 4,
    fill: "#2D2C2C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9675 16.0828H13.9883L15.2262 8.4292H17.2053L15.9675 16.0828Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1417 8.61637C22.7513 8.46151 22.1321 8.29053 21.3665 8.29053C19.4119 8.29053 18.0356 9.33267 18.0271 10.8226C18.0109 11.9219 19.0126 12.5325 19.7617 12.899C20.5275 13.2735 20.7878 13.518 20.7878 13.8518C20.78 14.3646 20.169 14.6009 19.5992 14.6009C18.809 14.6009 18.3856 14.4791 17.7422 14.1938L17.4816 14.0715L17.2046 15.7896C17.6688 16.0011 18.524 16.1887 19.4119 16.1969C21.4887 16.1969 22.8407 15.1709 22.8567 13.5831C22.8646 12.7119 22.3357 12.0443 21.1954 11.4988C20.5031 11.1486 20.0792 10.9124 20.0792 10.5541C20.0873 10.2284 20.4378 9.89475 21.2192 9.89475C21.8626 9.87841 22.3354 10.0331 22.6935 10.1878L22.8725 10.2691L23.1417 8.61637Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7731 13.3714C25.9361 12.9317 26.5633 11.23 26.5633 11.23C26.5551 11.2463 26.726 10.7822 26.8237 10.4972L26.962 11.1567C26.962 11.1567 27.3368 12.9887 27.4182 13.3714C27.1089 13.3714 26.164 13.3714 25.7731 13.3714ZM28.2162 8.4292H26.6853C26.2132 8.4292 25.8545 8.5675 25.6508 9.06422L22.7109 16.0827H24.7877C24.7877 16.0827 25.1296 15.1381 25.2031 14.9346C25.4309 14.9346 27.4511 14.9346 27.7442 14.9346C27.801 15.2033 27.9804 16.0827 27.9804 16.0827H29.8129L28.2162 8.4292Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.335 8.4292L10.3967 13.6482L10.1849 12.5897C9.82652 11.3684 8.70266 10.0414 7.44849 9.38162L9.2239 16.0747H11.3169L14.4278 8.4292H12.335Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.59681 8.4292H5.41246L5.37988 8.58386C7.86388 9.21906 9.50898 10.7502 10.1849 12.5905L9.49264 9.07263C9.37867 8.58375 9.02844 8.44533 8.59681 8.4292Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaDark);
export default __webpack_public_path__ + "static/media/visa_dark.a35964f73e94c71ebb7b5c8bbefb8218.svg";
export { ForwardRef as ReactComponent };